<template>
    <div class="slidenav">

        <hooper :settings='hooperSettings.main' ref="carousel" @slide="updateCarousel">
            <slide v-for="(slide, indx) in subenv" :key="indx" :index="indx">
                {{ slide.title }}
            </slide>
        </hooper>
        <a class="hooper-prev"
           v-bind:class="{disabled:disablePrev}"
           @click.prevent="slidePrev"
        ></a>
        <a class="hooper-next"
           v-bind:class="{disabled:disableNext}"
           @click.prevent="slideNext"
        ></a>
    </div>

</template>


<script>
    import {
        Hooper,
        Slide,
        // Navigation as HooperNavigation
    } from 'hooper';
    import 'hooper/dist/hooper.css';

    export default {
        name: "slidernav",
        props: ['subenv', 'activSubEnvironment'],
        data() {
            return {
                carouselData: 0,
                disableNext: false,
                disablePrev: false,
                hooperSettings: {
                    itemsToShow: 2,
                    centerMode: true,
                    infiniteScroll: true,
                    main: {
                        // infiniteScroll: true,
                        // initialSlide: 0,
                        // transition: 500,
                        // mouseDrag: false,
                        // shortDrag: false, // so it won't slide on mobile screen just by touching it
                        // wheelControl: false,
                    },
                }

            }
        },
        watch: {
            'carouselData'() {
                this.$refs.carousel.slideTo(this.carouselData);

                this.checkExtreme();
            },
            'activSubEnvironment'() {
                this.subenv.forEach((item, i) => {
                    if (item.id == this.activSubEnvironment.id) {
                        this.carouselData = i;
                    }
                });
            }

        },
        mounted() {
            this.subenv.forEach((item, i) => {
                if (item.id == this.activSubEnvironment.id) {
                    this.carouselData = i;
                }
            });
            this.checkExtreme();
        },
        methods: {
            checkExtreme() {
                if (this.carouselData == 0) {
                    this.disableNext = false;
                    this.disablePrev = true;
                } else if ((this.carouselData + 1) == this.subenv.length) {
                    this.disableNext = true;
                    this.disablePrev = false;
                } else {
                    this.disableNext = false;
                    this.disablePrev = false;
                }
            },
            slidePrev() {
                this.$refs.carousel.slidePrev();
            },
            slideNext() {
                this.$refs.carousel.slideNext();

            },
            updateCarousel(payload) {
                this.carouselData = payload.currentSlide;
                if (this.subenv.length >= payload.currentSlide) {
                    this.$emit('setActiveEnv', this.subenv[payload.currentSlide].id);
                }
            }
        },
        components: {
            Hooper,
            Slide,
        }
    }
</script>